export default __webpack_public_path__ + "static/media/plain-sticker-G.29393fca.png";